<template>
  <div v-if="in_electron && !(compact && newVersion)" class="check-updates">
    <BaseButton
      v-if="newVersion"
      :kind="compact ? 'main' : 'important'"
      type="secondary"
      :text="`Restart to update to ${newVersion}`"
      :tint="tint"
      @click="applyUpdates()"
    />
    <BaseButton
      v-else-if="checkingForUpdate"
      :kind="compact ? 'main' : 'important'"
      type="secondary"
      text="Checking for updates..."
      :tint="tint"
      state="loading"
    />
    <BaseButton
      v-else-if="downloading"
      :kind="compact ? 'main' : 'important'"
      type="secondary"
      text="Downloading updates..."
      :tint="tint"
      state="loading"
    />
    <BaseButton
      v-else
      :kind="compact ? 'main' : 'important'"
      type="secondary"
      text="Check for updates"
      :tint="tint"
      @click="checkUpdates()"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, watch } from "vue";

import controller from "@ctrl/controller";

import BaseButton from "@/components/base/BaseButton.vue";
import type { Tint } from "@/components/base/types";
import * as inject from "@/components/inject";
import { in_electron } from "@/utils/in";

const { applyUpdate, checkForUpdate } = controller;

export default defineComponent({
  components: { BaseButton },
  props: {
    compact: {
      type: Boolean,
      default: true,
    },
    tint: {
      type: String as PropType<Tint>,
      default: "none",
    },
  },
  emits: {
    newVersion: () => true,
  },
  setup(_, { emit }) {
    const checkingForUpdate = ref(false);
    const downloading = ref(false);
    const newVersion = inject.newVersion();
    const applyUpdates = () => applyUpdate();
    const checkUpdates = async () => {
      if (in_electron) {
        checkingForUpdate.value = true;
        const available = await checkForUpdate();
        checkingForUpdate.value = false;
        downloading.value = available;
      }
      // FIXME: Handle web
    };
    watch(newVersion, (value) => {
      downloading.value = false;
      if (value) emit("newVersion");
    });

    return {
      applyUpdates,
      checkingForUpdate,
      checkUpdates,
      downloading,
      in_electron,
      newVersion,
    };
  },
});
</script>
